module.exports = __webpack_public_path__ + "img/ios1icon6.d64b486a.png";